<template>
  <v-container
    fluid
    grid-list-lg
    class="pa-0"
  >
    <v-toolbar
      dark
      style="background:#af1c2e"
      fixed
      dense
    >
      <v-btn icon @click="goBack()">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title>Appointment</v-toolbar-title>
      <v-spacer/>
    </v-toolbar>

    <v-slide-y-transition mode="out-in">
      <v-card v-if="selectedAppointment">
        <v-card-text>
          <strong>
            <div v-if="selectedAppointment.Type">{{selectedAppointment.Type}} Appointment</div>
          </strong>
          <div v-if="selectedAppointment.Address">{{selectedAppointment.Address}}</div>
          <div v-if="selectedAppointment.Details">{{selectedAppointment.Details}}</div>
        </v-card-text>
      </v-card>
    </v-slide-y-transition>

    <v-list two-line subheader>
      <v-subheader>Primary Applicants</v-subheader>
      <template v-for="tenant in appointmentTenants">
        <v-list-tile
          :key="tenant.ID"
          avatar
        >
          <v-list-tile-avatar>
            <v-icon x-large>account_circle</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content @click="listItem_Click(tenant)">
            <v-list-tile-title>{{ tenant.Name }} {{ tenant.LastName }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ tenant.Email }}</v-list-tile-sub-title>
            <v-list-tile-sub-title>{{ tenant.Phone }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <!-- <v-btn fab dark small color="grey" v-if="tenant.Flag==3 || !tenant.Flag" @click="setFlag(tenant)"></v-btn>
          <v-btn fab dark small color="green" v-if="tenant.Flag==1" @click="setFlag(tenant)"></v-btn> -->
          <v-btn
            fab dark small
            @click="setFlag(tenant)"
            :color="flagColor(tenant)"
            style="align-self: flex-end;"
          />
          <v-list-tile-action>
            <v-btn icon ripple @click.stop="deleteTenant(tenant)">
              <v-icon color="red lighten-1">delete</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key="`divider_${tenant.ID}`"/>
      </template>
    </v-list>

    <v-btn
      absolute
      dark
      fab
      bottom
      right
      color="pink"
      @click.stop="dialog = !dialog; currentTenant={AppointmentID:appointmentID,ID:null,PersonID:0,Flag:3}; isNew = true;"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" width="800px" persistent>
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
          style="max-height: 50px;"
        >
          Applicant Details
        </v-card-title>
        <v-card-text class="pa-0">
          <v-container grid-list-sm>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  prepend-icon="person"
                  placeholder="First Name"
                  v-model="currentTenant.Name"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  placeholder="Last Name"
                  v-model="currentTenant.LastName"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  prepend-icon="mail"
                  placeholder="Email"
                  type="email"
                  :rules="emailRules"
                  v-model="currentTenant.Email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  type="tel"
                  prepend-icon="phone"
                  placeholder="(000) 000 - 00000"
                  mask="(###) ### - #####"
                  v-model="currentTenant.Phone"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12>
                <v-select
                  v-model="currentTenant.Flag"
                  :items="items"
                  label="Flag"
                ></v-select>
              </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-layout align-center justify-center v-if="currentTenant.id">
          <!--
          <v-btn v-if="!currentTenant.applicationID" color="primary" @click="emailApplication(currentTenant)">
            Email Application
          </v-btn>
          -->
          <div v-if="currentTenant.applicationID">
            Application <span v-if="currentTenant.applicationID !== 'new'" style="font-weight:bold">{{currentTenant.applicationID}}</span>
            sent
          </div>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions
          style="max-height: 50px;"
        >
          <v-btn flat color="primary" @click="currentTenant ={}; dialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click="saveTenant(currentTenant)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      dialog: false,
      appointmentID: null,
      isNew: false,
      currentTenant: {},
      formErrors: [],
      items: [
        { text: "Green", value: "1" },
        { text: "Red", value: "2" }
      ]
    }),
    computed: {
      ...mapGetters(["appointments", "selectedAppointment", "appointmentTenants", "allTenants"])
    },
    watch: {
      appointmentTenants: {
        handler: function(val, oldVal) {
          if (val !== oldVal) {
            if (this.currentTenant) {
              let cur = this.appointmentTenants.find(t => t.id == this.currentTenant.id);
              if (cur) {
                this.currentTenant = cur;
              }
            }
          }
        },
        deep: true
      }
    },
    methods: {
      goBack () {
        window.history.back();
      },
      listItem_Click (tenant) {
        this.currentTenant = tenant;
        this.isNew = false;
        this.dialog = true;
      },
      emailApplication (tenant) {
        this.$store.dispatch("saveTenant", tenant);
        let _this = this;
        this.$confirm("Do you wish to generate a unique application and email it to the primary applicant?").then(res => {
          if (res) {
            this.$store.dispatch("createApplication", tenant);
          }
        });
      },
      deleteTenant (tenant) {
        this.$confirm("Are you sure you wish to remove this tenant from the appointment?").then(res => {
          if (res) {
            this.$store.dispatch("removeTenant", tenant);
          }
        });
      },
      setFlag (tenant) {
        if (tenant.Flag == 1) {
          tenant.Flag = 2;
        } else {
          tenant.Flag = 1;
        }
        this.saveTenant(tenant, true);
        if (tenant.id && !tenant.applicationID) {
          this.$store.dispatch("createApplication", tenant);
        }
      },
      checkTenantForm () {
        let errors = [];
        if (this.currentTenant) {
          if (!this.currentTenant.Name) {
            errors.push("Tenant name is required.");
          }
          if (!this.currentTenant.Phone) {
            errors.push("Tenant phone is required.");
          }
        } else {
          errors.push("Invalid tenant information.");
        }
        this.formErrors = errors;
        return (this.formErrors.length <= 0);
      },
      saveTenant (tenant, noCheck) {
        if (this.checkTenantForm() || noCheck) {
          this.dialog = false;
          this.$store.dispatch("saveTenant", tenant);
        } else {
          if (this.formErrors) {
            this.formErrors.forEach(err => {
              console.log(err);
            });
          }
        }
      },
      flagColor (tenant) {
        switch (tenant.Flag) {
          case 2:
            return "red";
          case 1:
            return "green";
          default:
            return "grey";
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        let appointmentID = this.$route.params.id;
        this.appointmentID = appointmentID;
        this.$store.dispatch("openAppointment", appointmentID);
        this.$store.dispatch("setCurrentAppointmentID", appointmentID);
      });
    }
  };
</script>

<style scoped>
  .v-btn--floating {
    bottom: 10px;
    right: 10px;
  }
</style>
